import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for list  trade group 
export const TradeListGroup = createSlice({
  name: "TradeListGroup",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_TradeListGroup: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_TradeListGroup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_TradeListGroup: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    TradeListGroup_is_first: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default TradeListGroup.reducer;
export const {
  list_TradeListGroup,
  success_api_call_TradeListGroup,
  failure_api_call_TradeListGroup,
  TradeListGroup_is_first,
} = TradeListGroup.actions;
